var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selector"},_vm._l((_vm.categories),function(tiles,index){return _c('TileCategoryComponent',{key:index,attrs:{"tiles":tiles}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }